import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LIST_FADE_ANIMATION } from '../../../../@prep/shared/list.animation';

import { NotificationService } from './notification.service';

import { PlatformGlobalService } from '../../service/platform-global.service';
import { Subscription } from 'rxjs';

import { MatSnackBar } from '@angular/material/snack-bar';

import { LanguageSelectorModel } from 'src/@prep/shared/language-selector/model/language-selector.model';
import { LanguageSelectorService } from 'src/@prep/shared/language-selector/service/language-selector.service';
import { TopToolbarTextDataEN } from '../toolbar-multi-lang/en-US';
import { TopToolbarTextDataES } from '../toolbar-multi-lang/es-EU';
import { TopToolbarTextDataIT } from '../toolbar-multi-lang/it-IT';
import { HostListener, NgZone } from '@angular/core';

@Component({
  selector: 'prep-toolbar-notifications',
  templateUrl: './toolbar-notifications.component.html',
  styleUrls: ['./toolbar-notifications.component.scss'],
  animations: [...LIST_FADE_ANIMATION],
  providers: [NotificationService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarNotificationsComponent implements OnInit {
  @ViewChild('triggerBtn', { read: ElementRef }) triggerBtn: ElementRef;
  @ViewChild('notifPanel') notifPanel: ElementRef;

  notifications: any[];
  isOpen: boolean;
  notifyCount = 0;

  // number_of_notifications: number;

  selectedLang: LanguageSelectorModel =
    this.languageSelectorService.getCurrentLanguage();
  LangTextData: any;

  constructor(
    private notificationService: NotificationService,
    private platformGlobalService: PlatformGlobalService,
    private languageSelectorService: LanguageSelectorService,
    private snackbar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
  ) {
    this.languageSelectorService.language$.subscribe((lang) => {
      this.selectedLang = lang;
      console.log(
        '🌍 Language changed:',
        lang,
        lang.code,
        this.selectedLang.code
      );
      switch (this.selectedLang.code) {
        case 'en': {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'es': {
          this.LangTextData = TopToolbarTextDataES;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'it': {
          this.LangTextData = TopToolbarTextDataIT;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        default: {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 Default Language:', this.LangTextData);
          break;
        }
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isOpen) {
      this.closeAndReturnFocus();
    }
  }

  ngOnInit() {
    this.notifications = [];
    this.notifyCount =
      this.platformGlobalService.myUserInfo.number_of_notifications;
    // Authorize

    // Authorize
    // this.currentUserService.GetCurrentUser().subscribe(
    //   (response) => {
    //     this.platformGlobalService.me = response;
    //     this.platformGlobalService.user.subscribe((me) => {
    //       this.notifyCount = me.number_of_notifications;
    //     });
    //   },
    //   (error) => {
    //     console.log('error', error)
    //   }
    // );

    this.notificationService.getNotifyData().subscribe(
      (res) => {
        console.log('me', res);
        this.notifications = res.result;

        this.notifications.forEach((element) => {
          if (element.read === false) {
            this.notifyCount = this.notifyCount + 1;
          }
        });
      },
      (error) => {
        console.log('error', error);
      }
    );
  }

  markAsRead(notification) {
    notification.read = true;
  }

  dismiss(notification, event) {
    event.stopPropagation();
    if (this.notifyCount > 0) {
      this.notifyCount = this.notifyCount - 1;
    }
    this.notifications.splice(this.notifications.indexOf(notification), 1);

    let formData = {
      id: notification.id,
      read: true,
    };
    this.notificationService.postNotifyStatus(formData).subscribe(
      (res) => {
        this.snackbar.open(
          'Notification marked as read Successfully',
          '',
          {
            duration: 10000,
          }
        );
      },
      (error) => {
        console.log('error', error);
      }
    );
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
    this.cdr.detectChanges();
    if (this.isOpen) {
      this.zone.runOutsideAngular(() => {
        setTimeout(() => this.notifPanel?.nativeElement?.focus());
      });
    }
  }

  closeAndReturnFocus() {
    this.isOpen = false;
    this.cdr.detectChanges();
    this.triggerBtn?.nativeElement?.focus();
  }

  onClickOutside() {
    this.isOpen = false;
  }

  onPanelKeydown(event: KeyboardEvent) {
    if (event.key !== 'Tab') return;
    const panel = this.notifPanel?.nativeElement;
    if (!panel) return;
    const focusable = panel.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (focusable.length === 0) return;
    const first = focusable[0] as HTMLElement;
    const last = focusable[focusable.length - 1] as HTMLElement;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  markAllAsRead() {
    this.notifications.forEach((notification) => (notification.read = true));
  }
}
